import React, { Component } from "react";
//import { Prompt } from "react-router-dom";
import { withRouter } from 'react-router-dom'
//import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import HelpIcon from '@material-ui/icons/Help';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import Tooltip from '@material-ui/core/Tooltip';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import PropTypes from 'prop-types'
import RmaLogic from '../Logic/Logic'
import Divider from "./Divider";
import FormGroup from '@material-ui/core/FormGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Switch from '@material-ui/core/Switch'
import queryString from 'query-string'
import Typography from '@material-ui/core/Typography'
import ErrorBoundary from './ErrorBoundary'

class Search extends Component {
    static propTypes = {
        setDialogState: PropTypes.func.isRequired
    }
    constructor(props) {
        super(props);
        const isLocalhost = Boolean(
            window.location.hostname === 'localhost' ||
            // [::1] is the IPv6 localhost address.
            window.location.hostname === '[::1]' ||
            // 127.0.0.1/8 is considered localhost for IPv4.
            window.location.hostname.match(
                /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
            )
        );
        this.state = {
            isBlocking: false,
            orderId: '',
            zip: '',
            isCustomerMode: false,
            devMode: isLocalhost,
            testButtons: [
                {order:"111-9112359-2828216",zip:"42553",note:"latest issue"},
                {order:"7000208573",zip:"10506",note:"test resend"},
                {order:"111-6410161-8597036",zip:"33179",note:"Therese order issue"},
                {order:"SO1069353",zip:"29063",note:"RB denied issue"},
                {order:"SO1075089",zip:"01748",note:"reprint issue"},
                {order:"SO843205",zip:"98640",note:"03b05 "},
                {order:"7000133351",zip:"94015 ",note:"test missing line channel identifier"},
                {order:"700087769",zip:"03038 ",note:"stuck"},
                {order:"700084704",zip:"54929",note:"denied exchange"},
                { order: "700085254", zip: "11223", note: "krysta exchange example" },
                { order: "SO591052", zip: "39638", note: "FBA" },
                { order: "SO555287", zip: "30307", note: "missing denied images" },
                { order: "700079991", zip: "20678", note: "bad status" },
                { order: "700082421", zip: "K1R 7S7", note: "international" },
                { order: "700079840", zip: "19958", note: "$0 lines should not show as available for action" },
                { order: "700080931", zip: "75146", note: "exchange should be returnable" },
                { order: '700080560', zip: '08831', note: 'mispick' },
                { order: 'SO561838', zip: '86413', note: 'no return yet' },
                { order: 'SO554132', zip: '44119', note: 'Qty 2 exchanged both on two return orders' },
                { order: '700079973', zip: '46064', note: 'simple return' },
                { order: '700080396', zip: '19711', note: 'pending' },
                { order: 'SO507173', zip: '84118', note: 'lots of return orders, one missing shopfiy channel listing' },
                { order: '700071953', zip: '77538', note: 'initiated' },
                { order: 'SO540029', zip: '18447', note: 'mixed plus denied' },
                { order: 'SO461435', zip: '80014', note: 'too old' },
                { order: 'SO555835', zip: '63565', note: 'exchange tracking' },
                { order: 'SO549017', zip: '92860', note: '10W03 amazon/warehouse' },
                { order: 'SO560365', zip: '95765', note: '10W03 shopify' },
                { order: 'SO562187', zip: '85387', note: 'quantity 2' },
                { order: '700081141', zip: 'LS123UY', note: 'UK bad status' },
                { order: 'SO560854', zip: '95135', note: 'FBA only CS can exchange' },
                { order: '700080296', zip: '33770', note: 'Mail label test order. wrong size, too small' }
            ]
        }
    }

    // static getDerivedStateFromProps(props, state) {
    //     console.log("getDerivedStateFromProps")
    //     return { shouldBlockNavigation: true }
    // }

    loadTestOrder = async (order, zip) => {
        this.setState({ orderId: order, zip: zip })
        await this.forceUpdate()
        await this.beginSearch();
    }

    // getSnapshotBeforeUpdate(prevProps, prevState) {
    //     return {shouldBlockNavigation:true}
    //   }
    componentDidMount = () => {
        console.log("v7.0.0")
        var customerMode = localStorage.getItem('isCustomerMode') || 'false'
        this.setState({ isCustomerMode: customerMode === 'false' ? false : true })
        let params = queryString.parse(this.props.location.search)
        if (params && params.orderId) {
            if(params.for){
                this.setState({targetLine:params.for})
            }
            this.loadTestOrder(params.orderId, params.postalCode)
        }

        if (params && params.devMode) {
            this.setState({ devMode: true })
        }
        window.scrollTo(0, 0)
    }
    componentDidUpdate = () => {
        if (this.state.isBlocking)
            window.onbeforeunload = this.handleOnBeforeUnload;
        else
            window.onbeforeunload = this.handleOnBeforeUnload;
    }

    getIpAddress = async () => {
        try {
            if (!this.state.uip || this.state.uip === "") {
                await fetch("https://rmafunctionsv2.azurewebsites.net/api/Func/V2/RMA/GetIP?")
                    .then(res => res.text())
                    .then(data => this.setState({ uip: data }))
            }
            return this.state.uip
        } catch{
            this.props.setDialogState(false, '', <></>, <></>)
            this.props.history.push('/pages/returns/whoops')
        }
    }

    handleChange = name => event => {
        event.preventDefault()
        var val = event.target.value
        if (name === 'orderId') {
            val = val.toUpperCase().replace('S0', 'SO');
        }
        this.setState({ [name]: val });
    };

    handleKeyPress = name => event => {
        console.log(`Pressed keyCode ${event.key}`);
        if (event.key === 'Enter') {
            if (name === 'orderId') {
                console.log(this.zipInput)
                this.zipInput.focus()
                event.preventDefault()
            }
            if (name === 'zip') {
                this.beginSearch()
                event.preventDefault()
            }
        }
    }

    setCustomerMode = (value) => {
        this.setState({ isCustomerMode: value })
        localStorage.setItem('isCustomerMode', value)

    }

    beginSearch = async () => {
        try {
            this.props.setDialogState(true, 'Searching for your Order', <CircularProgress />, <></>)
            let ip = await this.getIpAddress()
            let l = new RmaLogic();
            let results = await l.findOrder(this.state.orderId, this.state.zip, this.state.isCustomerMode ? 'Test' : null, ip)
            localStorage.setItem('orderInfo', JSON.stringify(results));
            this.props.setDialogState(false, 'Searching', <CircularProgress />, <div>Searching for your Order</div>)
            if (results.orderFound) {
                if (this.state.targetLine) {
                    this.props.history.push('/pages/returns/status?for=' + this.state.targetLine)
                } 
                else {
                    this.props.history.push('/pages/returns/status')
                }
            }

            if(!results.orderFound) {
                if(results?.isReturnBotExcluded){
                    this.props.history.push('/pages/returns/orderRestriction')
                    return;
                }
                this.props.history.push('/pages/returns/orderNotFound')
            }
        } catch{
            this.props.setDialogState(false, '', <></>, <></>)
            this.props.history.push('/pages/returns/whoops')
        }
    }

    render() {
        const orderHelpText = 'Your order number can be found on your packing slip or in your order confirmation email. Example formats include "7000123456," "SO123456," or "111-123456-123456".';
        return (
            <ErrorBoundary>
                <form onSubmit={this.beginSearch}>
                    <div>{this.state.isBlocking}</div>

                    <Grid container direction="row" justify="flex-start" alignItems="center" spacing={0}>
                        <Grid item xs={11} >
                            <h3 style={{ margin: 3 }} >Start Your Return or Exchange Here</h3>
                        </Grid>
                    </Grid>

                    <FormControl
                        // variant="outlined"
                        fullWidth
                        margin="normal"
                        variant="standard"
                    >
                        <InputLabel >Order Number:</InputLabel>
                        <Input
                            className="searchInput"
                            id="orderId"
                            type="text"
                            variant="standard"
                            ref={(input) => { this.orderNumberInput = input; }}
                            onKeyPress={this.handleKeyPress('orderId')}
                            value={this.state.orderId}
                            onChange={this.handleChange('orderId')}
                            endAdornment={
                                <InputAdornment position="end">
                                    <Tooltip title={orderHelpText} style={{ maxWidth: 'none' }} leaveDelay={6000} enterTouchDelay={100}>
                                        <HelpIcon color="primary" />
                                    </Tooltip>
                                </InputAdornment>
                            }
                        />
                    </FormControl>



                    <Grid container direction="row" justify="flex-start" alignItems="center" spacing={0}>
                        <FormControl
                            // variant="outlined"
                            fullWidth
                            margin="normal"
                            variant="standard"
                        >
                            <InputLabel >Zip Code:</InputLabel>
                            <Input
                                id="zip"
                                type="text"
                                variant="standard"
                                onKeyPress={this.handleKeyPress('zip')}
                                inputProps={{ ref: input => this.zipInput = input }}
                                value={this.state.zip}
                                onChange={this.handleChange('zip')}

                            />
                        </FormControl>


                    </Grid>

                    <Grid container direction="row" justify="flex-start" alignItems="center" >
                        <Button variant="outlined" color="primary" style={{ marginTop: 10 }} onClick={this.beginSearch} >
                            Find Order
            </Button>
                    </Grid>

                    {this.state.devMode ?

                        <Grid container direction="column" justify="flex-start" alignItems="flex-start" >
                            <Grid item>
                                <FormGroup row>
                                    <FormControlLabel
                                        control={
                                            <Switch checked={this.state.isCustomerMode}
                                                onChange={(event) => this.setCustomerMode(event.target.checked)}
                                                value={this.state.isCustomerMode} />
                                        }
                                        label="Run as Customer"
                                    />
                                </FormGroup>
                            </Grid>
                            {this.state.testButtons.map((v, i) =>
                                <Grid key={i} style={{ marginTop: 2 }} container direction="row" justify="flex-start" alignItems="flex-start" >
                                    {i === 0 ? <Divider /> : <></>}
                                    <Grid item>
                                        <Button variant="outlined"
                                            color="secondary"
                                            onClick={() => window.open(`https://www.braceability.com/pages/returns?orderId=${v.order}&postalCode=${v.zip}`, "_blank")}>Old</Button>
                                    </Grid>
                                    <Grid item>
                                        <Button variant="outlined"
                                            color="secondary"
                                            onClick={() => window.open(`https://braceability.fulfil.io/client/#/model/sale.sale?actWinId=239&currentTabDomainId=80&searchQuery=${v.order}&page=1`, "_blank")}>FF</Button>
                                    </Grid>
                                    <Grid item>
                                        <Button variant="outlined"
                                            style={{ minWidth: 120, marginLeft: 2 }}
                                            color="secondary"
                                            onClick={() => this.loadTestOrder(v.order, v.zip)}>
                                            {v.order}/{v.zip}
                                        </Button>
                                    </Grid>
                                    <Grid item>
                                        <p style={{ marginLeft: 5 }}>{v.note}</p>
                                    </Grid>

                                </Grid>
                            )}
                            <Button color="primary" variant="outlined" onClick={this.renderFonts} >Font Maddness</Button>
                        </Grid>
                        :
                        <></>}

                </form>

            </ErrorBoundary >
        );

    }


    renderFonts = () => {
        const testText = " ABCDEFGHIJKLMNOPQRST abcedfghijklmnopqrst 1234567890 !@#$%^&*(){}[] A BC DEF GHIJ KLMNO PQRSTa bcedfgh ijklmnop qrst123456 7890!@#$%^& *(){}[]"
        const fonts = <div>
            <Typography variant="h1" display="block" component="div">(h1){testText}</Typography>
            <Typography variant="h2" display="block" component="div">(h2){testText}</Typography>
            <Typography variant="h3" display="block" component="div">(h3){testText}</Typography>
            <Typography variant="h4" display="block" component="div">(h4){testText}</Typography>
            <Typography variant="h5" display="block" component="div">(h5){testText}</Typography>
            <Typography variant="h6" display="block" component="div">(h6){testText}</Typography>
            <Typography variant="subtitle1" display="block" component="div">(subtitle1){testText}</Typography>
            <Typography variant="subtitle2" display="block" component="div">(subtitle2){testText}</Typography>
            <Typography variant="body1" display="block" component="div">(body1){testText}</Typography>
            <Typography variant="body2" display="block" component="div">(body2){testText}</Typography>
            <Typography variant="button" display="block" component="div">(button){testText}</Typography>
            <Typography variant="caption" display="block" component="div">(caption){testText}</Typography>
            <Typography variant="overline" display="block" component="div">(overline){testText}</Typography>
            <Divider />
        </div>

        this.props.setDialogState(true, 'Font maddness', fonts, <></>, true, true)


    }

}



export default Search = withRouter(Search)